module.exports = __webpack_public_path__ + "img/symbol_5.1e4502a8.png";